var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showFllow)?_c('Follow',{attrs:{"show":_vm.showFllow},on:{"update:show":function($event){_vm.showFllow=$event}}}):_vm._e(),(_vm.showPhone)?_c('Bind-Phone'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }